import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Popover } from '@mui/material'
import { POLICY_TYPE_BIKE } from 'src/utils/constants/BuyPolicyBike'
import EmptyInsuranceDetails from 'src/components/BuyPolicy/common/EmptyInsuranceDetails'
import ComprehensivePlan from 'src/components/BuyPolicy/insuranceScreens/motor/ComprehensivePlan'
import { useDispatch, useSelector } from 'react-redux'
import { updateCurrentPolicyDetailsMotor } from 'src/actions'
import OwnDamageDetailsPopover from 'src/components/BuyPolicy/insuranceScreens/bike/OwnDamageDetailsPopover'
import { addScroll, removeScroll } from 'src/utils/commonMethods'

const ExplorePolicyTypes = ({
  quickQuote,
  loading,
  loadingQuote,
  isTwoWheeler,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const [selectedContainer, setSelectedContainer] = useState(
    motorDetails.currentPolicyDetails?.policyType
  )
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)
  const [popoverAnchor, setPopoverAnchor] = useState(null)

  const closePopover = () => {
    setIsPopoverOpen(false)
    setPopoverAnchor(null)
    addScroll()
  }

  const handleExploreContainerSelect = (event, container) => {
    setSelectedContainer(container)
    if (container === POLICY_TYPE_BIKE?.OWNDAMAGE) {
      openPopover(event)
    } else {
      dispatch(
        updateCurrentPolicyDetailsMotor({
          ...motorDetails.currentPolicyDetails,
          policyType: container,
        })
      )
    }
  }
  const openPopover = (event) => {
    setPopoverAnchor(event?.currentTarget)
    setIsPopoverOpen(true)
    removeScroll()
  }
  return (
    <Box>
      <Popover
        id={'popover'}
        open={isPopoverOpen}
        anchorEl={popoverAnchor}
        onClose={closePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <OwnDamageDetailsPopover
          closePopover={closePopover}
          container={selectedContainer}
        />
      </Popover>
      <Box className={classes.exploreBuyThridParty}>
        <Box className={classes.exploreBuyTabs}>
          <Box className={classes.switchContainer}>
            <Box className={classes.switchContainerMain}>
              <Box
                className={`${classes.insuranceCategoryContainer} ${
                  selectedContainer === POLICY_TYPE_BIKE?.COMPREHENSIVE
                    ? classes.selected
                    : classes.notSelected
                }`}
                onClick={(event) =>
                  handleExploreContainerSelect(
                    event,
                    POLICY_TYPE_BIKE?.COMPREHENSIVE
                  )
                }
                id='comprehensive-tab-explore'
              >
                <Box className={classes.comprehensiveText}>COMPREHENSIVE</Box>
              </Box>

              <Box
                className={`${classes.insuranceCategoryContainer} ${
                  selectedContainer === POLICY_TYPE_BIKE?.OWNDAMAGE
                    ? classes.selected
                    : classes.notSelected
                }`}
                onClick={(event) =>
                  handleExploreContainerSelect(
                    event,
                    POLICY_TYPE_BIKE?.OWNDAMAGE
                  )
                }
                id='comprehensive-tab-explore'
              >
                <Box className={classes.ownDamageText}>OWN DAMAGE </Box>
              </Box>

              <Box
                className={`${classes.insuranceCategoryContainer} ${
                  selectedContainer === POLICY_TYPE_BIKE?.THIRD_PARTY
                    ? classes.selected
                    : classes.notSelected
                }`}
                onClick={(event) =>
                  handleExploreContainerSelect(
                    event,
                    POLICY_TYPE_BIKE?.THIRD_PARTY
                  )
                }
                id='thirdParty-tab-explore'
              >
                <Box className={classes.thirdPartyText}>THIRD PARTY</Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={classes.quoteList}>
        {quickQuote?.length !== 0 ? (
          <Box>
            {quickQuote?.map((item) => {
              return (
                <ComprehensivePlan
                  length={quickQuote?.length}
                  quote={item}
                  logo={item?.providerImage}
                  idvCover={item?.idvCover}
                  price={item?.grossTotalPremium}
                  recommend={true}
                  key={item?.providerId}
                  paCover={motorDetails?.currentPolicyDetails?.paCover}
                  policyType={motorDetails?.currentPolicyDetails?.policyType}
                  isTwoWheeler={isTwoWheeler}
                />
              )
            })}
          </Box>
        ) : (
          <Box>
            {!loadingQuote && !loading ? <EmptyInsuranceDetails /> : null}
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default ExplorePolicyTypes

const useStyles = makeStyles({
  exploreBuyThridParty: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    padding: 20,
  },
  exploreBuyTabs: {
    display: 'flex',
    justifyContent: 'center',
  },
  switchContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    maxWidth: '553px',
    padding: '5px 10px',
  },
  switchContainerMain: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '3px',
    padding: '8px',
  },

  insuranceCategoryContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5,
    padding: '0px 10px 0px 10px',
    cursor: 'pointer',
    height: '30px',
    color: '#2BA6C8',
  },

  thirdPartyText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16.41px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: ' #2A768B',
  },
  comprehensiveText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16.41px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: ' #2A768B',
  },
  ownDamageText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16.41px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: ' #2A768B',
  },
  selected: {
    background: 'linear-gradient(90.26deg, #4DC3E3 -187%, #FFFFFF 160.02%)',
    borderRadius: 8,
    boxShadow: '0px 4px 4px 0px #00000033',
    color: '#464646',
  },
  notSelected: {},
  quoteList: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'center',
  },
})
